import {
  PERMISSION_CANTILEVER_ACCESS_ADMIN,
  RolodexPermissionsValues,
} from 'types'

export const MANAGE_USER_PERMISSIONS_PERMISSIONS_LIST: RolodexPermissionsValues[] =
  [PERMISSION_CANTILEVER_ACCESS_ADMIN]
